import {string, type} from 'io-ts';
import {nullable} from '~/library/io-ts-tools';
import {ErroneousServerResult, HttpClient, expectOneOf} from '~/library/network-facade';
import {NonNegativeInt} from '~/library/types';

const SmsDeliverySchema = type({
    code: NonNegativeInt,
    message: nullable(string),
});

export const smsDeliveryStatus = (http: HttpClient, tenantUuid: string) =>
    http(`v1/public/tenant/sms/${tenantUuid}`).then(
        expectOneOf({
            200: SmsDeliverySchema,
            400: ErroneousServerResult,
            404: ErroneousServerResult,
            401: null,
        })
    );
